let path = '';
if (window.location.pathname.includes('/collections')) {
  path = window.location.pathname;
}

const productItemDataList = [];

if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
      enableSeo: false,
      enableKeepScrollbackPosition: true, // Scroll to the previous position after going back from Product page
	  keepScrollbackPositionType: 'sessionStorage' // Where to save the scrollback position data: 'sessionStorage' or 'history'
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble',
    },
  };
}

var boostPFSInvalidPageRobotsMetaId = 'boost-pfs-invalid-page-noindex';

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];

  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop =
    jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile()
      ? '.boost-pfs-filter-left-col'
      : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    // var imageAspectRatio = (ratioImage / getAspectRatio(data.images_info[0])) * 100;
    var imageAspectRatio = 1 * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(
      /{{cardBadgePosition}}/g,
      boostPFSThemeConfig.custom.badge_position
    );
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add Label items
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add card info collapse price
    itemHtml = itemHtml.replace(/{{cardInfoPrice}}/g, `
    <div class="collection-sneakers__list__card__info__price" id="product-price-wrapper--${data.id}">{{itemPrice}}</div>
    `);
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, `
      <div class="variant-price d-block-img" id="main-variant-price--${data.id}-${data.id}">
        ${buildPrice(data)}
      </div>
      <div data-color_count_id="${data.id}" class="sneakers__list__card__info__color_count"></div>
    `);
    // Add sub title
    itemHtml = itemHtml.replace(/{{cardInfoSubTitle}}/g, buildSubTitle(data));
    // Add card Info Collapse
    itemHtml = itemHtml.replace(/{{cardInfoCollapse}}/g, buildCardInfoCollapse(data));

    // Add Review
    if (
      typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
      // itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildRivyoV2Review(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(
      /{{itemDescription}}/g,
      boostPFSThemeConfig.custom.description || ''
    );

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Show Compare
    itemHtml = itemHtml.replace(/c-compare-hidden/g, buildCompareShowClass(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    const productUrl = Utils.buildProductItemUrlWithVariant(data);

    let isApparel = '';
    if (data.tags.includes('トップス') || data.tags.includes('ボトムス')) {
      isApparel = 'apparel-image';
    }

    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage =
        !Utils.isMobile() &&
        images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet +=
          Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet +=
            Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') +
            ' ' +
            rangeWidths[i] +
            'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += `<div class="media--transparent media--hover-effect" style="height: 100%;" id="product-media-wrapper--${data.id}">`;

      // render first image
      html +=
        `<a href="${path}${productUrl}" class="collection-sneakers__list__card__img__link">` +
        `<div class="collection-sneakers__list__card__img__img first-image d-block-img ${isApparel}"` +
        `style="height: 100%; background-image: url('${images[0].src}')">` +
        '</div>' +
        '</a>';

      // render secondary image
      if (activeSwapImage) {
        html +=
          `<a href="${path}${productUrl}" class="collection-sneakers__list__card__img__link">` +
          `<div class="collection-sneakers__list__card__img__img secondary-image d-none-img ${isApparel}"` +
          `style="height: 100%; background-image: url('${images[1].src}&width=1000')">` +
          '</div>' +
          '</a>';
      }

      // render image color available
      var array_color = '';
      let item_image = "";
      data.variants.forEach((item, index) => {
        var color = item.title.split('/')[0];
        if (item.available) {
          if (!array_color.includes(color)) {
            array_color = array_color.concat(color);
            let image_src = document.getElementById(``);
            html +=
              `<a href="${path}${productUrl}" class="collection-sneakers__list__card__img__link">` +
              `<div class="collection-sneakers__list__card__img__img ${index} d-none-img ${isApparel}"` +
              `style="height: 100%; background-image: url('{{variantItemImage}}')">` +
              '</div>' +
              '</a>';
          }
        }
        if(item_image === "" && item.image !== "") item_image = item.image;
      });
      html = html.replace(/{{variantItemImage}}/g, item_image);

      const listTagLeft = ['限定版', 'COMING_SOON', '新着'];
      const listTagRight = [
        'S/LAB',
        'GORE-TEX',
        'BLUE_FIRE_COLLECTION',
        'BOA',
        'MIPS',
        'PACK',
        'MTN',
        'SIGMA',
      ];
      // render sticker text and sticker image
      html += '<div class="list-tag-left">';
      data.tags.forEach(tag => {
        if (listTagLeft.includes(tag)) {
          html += `<span class="sticker-text">${tag}</span>`;
        }
      });
      listTagRight.forEach(tag => {
        const tagLowercase = tag.toLowerCase();
        if (data.tags.includes(tag)) {
          html += `<img class="sticker-image" src="https://cdn.shopify.com/s/files/1/0673/9981/1381/files/${
            tagLowercase == 's/lab' ? 'slab' : `${tagLowercase}`
          }.svg" width="40" height="40">`;
        }
      });
      html += '</div>';

      html += '<div class="list-tag-right">';
      html += '</div>';

      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildCompareShowClass(data) {
    var html = '';
    if(data.tags?.find(tag => tag.includes("シューズ"))) {
      html = '';
    }else {
      html = 'c-compare-hidden';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true
    ) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildSubTitle(data) {
    var subTitle = '';
    // const metafieldGender = data.metafields.find(metafield => metafield.key === 'gender');
    const metafieldType1 = data.metafields.find(metafield => metafield.key === 'type_1');
    const metafieldType2 = data.metafields.find(metafield => metafield.key === 'type_2');
    // 2024.8.16 Hidden metafieldGender
    // subTitle += metafieldGender
    //   ? `<span class="collection-sneakers__list__card__info__subtitle">${metafieldGender.value} - </span>`
    //   : '';
    subTitle += metafieldType1
      ? `<span class="collection-sneakers__list__card__info__subtitle">${metafieldType1.value}</span>`
      : '';
    subTitle += metafieldType2
      ? `<span class="collection-sneakers__list__card__info__subtitle"> - ${metafieldType2.value}</span>`
      : '';
    return subTitle;
  }

  // 2023.11.2 Add start : Fetch product info function
  function getJSON(url, qs_params) {
    function buildQueryString(params) {
      return Object.entries(params).map(d => `${d[0]}=${d[1]}`).join('&');
    }
  
    return new Promise((resolve, reject) => {
      const qs = qs_params ? '?' + buildQueryString(qs_params) : '';
      const xhr = new XMLHttpRequest();
      xhr.open('GET', `${url}${qs}`);
  
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 400) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          resolve(xhr.responseText);
        }
      };
      xhr.onerror = () => reject(xhr.statusText);
      xhr.send();
    });
  }
  function fetchProduct(itemHandle) {
    return new Promise(resolve => {
      const requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };
      getJSON(window.Shopify.routes.root + `products/${itemHandle}.js`, requestOptions)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          resolve(productItem);
        });
    })
  }
  // 2023.11.2 Add end  : Fetch product info function

  function buildCardInfoCollapse(data) {
    const productUrl = Utils.buildProductItemUrlWithVariant(data);
    const metafieldNotForSale = data.metafields.find(metafield => metafield.key === 'not_for_sale');
    const isNotForSale = metafieldNotForSale ? metafieldNotForSale.value : false;
    var variantsInfo = '';
    const renderColorItemList = [];
    renderColorItemList.push(Number(data.id));
    //render list color
    // 2023.11.2 Modify : Get other colors from the product metafield
    //  Get the product handle from the product meta field, fetch and then display other colors
    variantsInfo += '<div class="c-variant-slider">';
    variantsInfo += '<div class="c-variant-slider__container" data-scrollbar="horizontal">';
    variantsInfo += '<div class="c-variant-slider__track" data-scroll-content>';
    var array_color = '',
      indexColor = 0;
    // ① Default color
    let item_image = "";
    const isBundle = data.tags.includes('bundle_product');

    if(isBundle){
      indexColor = indexColor + 1;
      const isSoldout = !data.available;
      const soldoutClass = isSoldout ? ' is-soldout' : '';
      variantsInfo +=
        `<div class="c-variant-slider__item" data-other_color_variant_id="${data.handle}">` +
        `<a href="${path}${productUrl}" class="c-variant-slider__link ${soldoutClass}"  data-product-url="${path}${productUrl}" data-product-id="${data.id}">` +
        `<img class="c-variant-slider__img 0 ${indexColor} ${soldoutClass}" src="{{item_image}}&width=800" id="variant-color--${data.id}-0" data-color_id="${data.id}" width="100" height="100">` +
        '</a>' +
        '</div>';

        if(data.images[0]) {
          item_image = data.images[0];
        }else if(data.images[1]){
          item_image = data.images[1];
        }else if(data.featured_image){
          item_image = data.featured_image;
        }
     } else {
      data.variants.forEach((item, index) => {
        var color = item.title.split('/')[0];
        // if (item.available && item.weight === 0) {
        if (item.weight === 0) {
          if (!array_color.includes(color)) {
            array_color = array_color.concat(color).concat(',');
            indexColor = indexColor + 1;
            const isSoldout = !data.available;
            const soldoutClass = isSoldout ? ' is-soldout' : '';
            variantsInfo +=
              `<div class="c-variant-slider__item" data-other_color_variant_id="${data.handle}">` +
              `<a href="${path}${productUrl}" class="c-variant-slider__link ${soldoutClass}"  data-product-url="${path}${productUrl}" data-product-id="${data.id}">` +
              `<img class="c-variant-slider__img ${index} ${indexColor} ${soldoutClass}" src="{{item_image}}&width=800" id="variant-color--${data.id}-0" data-color_id="${data.id}" width="100" height="100">` +
              '</a>' +
              '</div>';
          }
        }
        if(item_image === "" && item.image !== "") item_image = item.image;
      });
    }
    variantsInfo = variantsInfo.replace(/{{item_image}}/g, item_image);
    
    // productItemDataListにidが一致するアイテムがない場合、productItemDataListに追加
    if(!productItemDataList.find(item => item.id === data.id)){
      productItemDataList.push(data);
    }

    // ② Other color
    const productOtherColorList = data.metafields.find(metafield => metafield.key === "other_color" && metafield.namespace === "custom");
    if(productOtherColorList && productOtherColorList?.value !== ""){
      const productOtherColorList_Parsed = JSON.parse(productOtherColorList.value);
      productOtherColorList_Parsed.forEach(otherColorHandle => {
        // 初期状態でhiddenクラスを付与
        variantsInfo += `<div class="hidden c-variant-slider__item" id="${otherColorHandle}" data-other_color_variant_id="${otherColorHandle}"></div>`
      });

      // Fetch other color products
      (async () => {
        const fetchProducts = productOtherColorList_Parsed.map(itemHandle => fetchProduct(itemHandle));
        let indexOtherColor = 1;

        await Promise.all(fetchProducts)
          .then( (result) => {
            // Rendering of other color products
            const otherColorItemList = result.filter(item => typeof item === 'object' && item);

            otherColorItemList.forEach((colorItem,index) => {
              // If the Color has already been displayed due to a registration error, continue
              if(renderColorItemList.indexOf(colorItem.id) > -1){
                return;
              }else{
                renderColorItemList.push(Number(colorItem.id));
              }

              // If sale or outlet collections, only sale items are shown
              if((path.indexOf('-sale') > -1 || path.indexOf('-outlet') > -1)
                && colorItem.compare_at_price_min <= colorItem.price_min
              ){
                return
              }

              // productItemDataListにidが一致するアイテムがない場合、productItemDataListに追加
              if(!productItemDataList.find(item => item.id === colorItem.id)){
                productItemDataList.push({
                  id: colorItem.id,
                  title: colorItem.title,
                  handle: colorItem.handle,
                  url: colorItem.url,
                  price: colorItem.price / 100,
                  price_min: colorItem.price_min / 100,
                  compare_at_price: colorItem.compare_at_price / 100,
                  compare_at_price_min: colorItem.compare_at_price_min / 100,
                  price_varies: colorItem.price_min !== colorItem.compare_at_price_min,
                  tags: colorItem.tags,
                  skus: colorItem.skus,
                  variants: colorItem.variants,
                  vendor: colorItem.vendor,
                  options: colorItem.options,
                  options_with_values: colorItem.options_with_values,
                  images: colorItem.images,
                  featured_image: colorItem.featured_image,
                  available: colorItem.available,
                  weight: colorItem.weight,
                  compare_at_price_varies: colorItem.compare_at_price_varies,
                  selected_or_first_available_variant: colorItem.selected_or_first_available_variant,
                  unit_price_measurement: colorItem.unit_price_measurement,
                });
              }

              // Image render
              const featured_image = colorItem.variants[0]?.featured_image ? colorItem.variants[0]?.featured_image.src : colorItem.featured_image;
              
              // 売り切れ状態をチェック
              const isSoldout = !colorItem.available;
              const soldoutClass = isSoldout ? ' is-soldout' : '';

              let colorVariantInfo = `
                  <a href="${colorItem.url}" class="c-variant-slider__link ${soldoutClass}" data-product-url="${colorItem.url}" data-product-id="${colorItem.id}">
                    <img class="c-variant-slider__img ${index + 1} ${indexOtherColor}${soldoutClass}" src="${featured_image}&width=800" id="variant-color--${data.id}-${index + 1}" width="800" height="800">
                  </a>
              `;
              
              let renderOtherColorItemList = document.querySelectorAll(`[data-other_color_variant_id="${colorItem.handle}"]`);
              if(renderOtherColorItemList.length > 0){
                renderOtherColorItemList.forEach(otherColorItem => {
                  otherColorItem.innerHTML = colorVariantInfo;
                  // productInfo取得成功時にhiddenクラスを削除
                  otherColorItem.classList.remove('hidden');
                });
                indexOtherColor = indexOtherColor + 1;
              }
            });
          } ) 
          .catch( function (error) {
            console.error(error);
          } );

        // 画像プリロード機能
        const preloadVariantImages = () => {
          const cardList = document.querySelectorAll('.boost-pfs-filter-products .grid__item');
          
          cardList.forEach(card => {
            const variantSlider = card.querySelector('.c-variant-slider');
            if (!variantSlider) return;
            
            const variantImages = variantSlider.querySelectorAll('.c-variant-slider__img');

            // 各バリエーション画像を事前読み込み
            variantImages.forEach(img => {
              if (img.src) {
                // 画像オブジェクトを作成してプリロード
                const preloadImg = new Image();
                preloadImg.src = img.src; 
              }
            });
          });
        };

        // バリエーション画像切り替え機能
        const initVariantImageSwitcher = () => {
          const cardList = document.querySelectorAll('.boost-pfs-filter-products .grid__item');
          
          cardList.forEach(card => {
            const variantSlider = card.querySelector('.c-variant-slider');
            const mainImageContainer = card.querySelector('.card__media');
            
            if (!variantSlider || !mainImageContainer) return;
            
            const variantLinks = variantSlider.querySelectorAll('.c-variant-slider__link');
            const mainImage = mainImageContainer.querySelector('.collection-sneakers__list__card__img__img');
            const mainImageLink = mainImageContainer.querySelector('.collection-sneakers__list__card__img__link');
            
            variantLinks.forEach(link => {
              link.addEventListener('click', (e) => {
                e.preventDefault();
                
                const clickedItem = link;
                const thumbnailImg = clickedItem.querySelector('.c-variant-slider__img');
                const subTitleHTML = clickedItem.closest('.grid__item').querySelector('.collection-sneakers__list__card__info__subtitle') ? clickedItem.closest('.grid__item').querySelector('.collection-sneakers__list__card__info__subtitle').innerHTML : "";
                const colorCountHTML = clickedItem.closest('.grid__item').querySelector('[data-color_count_id]') ? clickedItem.closest('.grid__item').querySelector('[data-color_count_id]').innerHTML : "";
                
                if (!thumbnailImg || !mainImage) return;
                
                // クリックした画像のsrc URLを取得
                const srcUrl = thumbnailImg.src;
                
                if (!srcUrl) return;
                
                // メイン画像のbackground-imageを切り替え
                mainImage.style.backgroundImage = `url('${srcUrl}')`;
                
                // メイン画像のリンクを更新
                const productUrl = link.getAttribute('href');
                if (productUrl && mainImageLink) {
                  mainImageLink.href = productUrl;
                }

                // Informationを更新
                const colorVariantId = clickedItem.getAttribute('data-product-id');
                const productInfo = productItemDataList.find(item => item.id === parseInt(colorVariantId));
                let informationHTML = `
                                  {{itemLabels}}
                  <h3>
                    <a href="{{itemUrl}}" class="full-unstyled-link">
                      {{itemTitle}}
                    </a>
                  </h3>
                  <span class="collection-sneakers__list__card__info__subtitle">
                    {{cardInfoSubTitle}}
                  </span>
                  <div style="height: 1rem; display: block;"></div>
                  {{itemPrice}}`;
                informationHTML = informationHTML.replace(/{{itemLabels}}/g, buildLabels(productInfo));
                informationHTML = informationHTML.replace(/{{itemUrl}}/g, "/products/" + productInfo.handle);
                informationHTML = informationHTML.replace(/{{itemTitle}}/g, productInfo.title);
                // informationHTML = informationHTML.replace(/{{cardInfoSubTitle}}/g, buildSubTitle(productInfo));
                // cardInfoSubTitle: メタフィールド取得ができないため親データを参照
                informationHTML = informationHTML.replace(/{{cardInfoSubTitle}}/g, subTitleHTML);
                informationHTML = informationHTML.replace(/{{itemPrice}}/g, `
                  <div class="variant-price d-block-img" id="main-variant-price--${productInfo.id}-${productInfo.id}">
                    ${buildPrice(productInfo)}
                  </div>
                  <div data-color_count_id="${data.id}" class="sneakers__list__card__info__color_count">
                    ${colorCountHTML}
                  </div>
                `);
                card.querySelector('.collection-sneakers__list__card__info').innerHTML = informationHTML;

                // Reviewのリンク先を更新
                const reviewLink = card.querySelector('.collection-sneakers__list__card__reviews__link');
                if (reviewLink) {
                  reviewLink.href = "/products/" + productInfo.handle + "#wc_review_section";
                  reviewLink.querySelector('.collection-sneakers__list__card__reviews__product_name').textContent = productInfo.title;
                }
                
                // 選択中のバリエーションをハイライト
                variantSlider.querySelectorAll('.c-variant-slider__item').forEach(item => {
                  item.classList.remove('active');
                });
                clickedItem.classList.add('active');
              });
            });
          });
        };

        // 動的コンテンツ生成後に画像切り替え機能を初期化
        setTimeout(() => {
          preloadVariantImages();
          initVariantImageSwitcher();
        }, 100); 

        // スクロールバーを初期化
        if (typeof initScrollbar === 'function') {
          initScrollbar('[data-scrollbar="horizontal"]', { direction: 'horizontal' });
        }

        if(indexOtherColor > 1) {
          document.querySelectorAll(`[data-color_count_id="${data.id}"]`).forEach(elem => {
            elem.innerHTML = `<span>${indexOtherColor}カラー</span>`;
          });
        }
      })();
    }

    variantsInfo += `</div>`;


    // 2023.11.2 Modify isNotForSale condition
    // if (!isNotForSale === false || isNotForSale === 'false') {
    if (isNotForSale === false || isNotForSale === 'false') {
      // render list size of color
      variantsInfo += `<div class="hidden collection-sneakers__list__card__info__size mb-1" id="product-size-wrapper--${data.id}">`;

      var display = "d-flex";
      variantsInfo += `<div class="variant-size 1 ${display} default-item" id="main-variant-size--${data.id}-${data.id}">`;
      data.variants.forEach(variant => {
        if (variant.available) {
          var sizeItem = variant.option2;
          variantsInfo += `
          <a href="${path}${productUrl}" class="link-variant-size mr-1">
            <span>${sizeItem}</span>
          </a>`;

        }
      });
      variantsInfo += '</div>';
      variantsInfo += '</div>';
              variantsInfo += '</div>';
        variantsInfo += '</div>';
      }

      return variantsInfo;
  }

  function buildPrice(data) {
    var productPrice = '';
    const priceMin = data.price_min;
    const compareAtPriceMin = data.compare_at_price_min;

    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount =  Utils.formatMoney(priceMin);
    const isBundle = data.tags.includes('bundle_product');
    if(isBundle && data.price_min !== data.price_max) {
      priceAmount = `${Utils.formatMoney(priceMin)} ~ ${Utils.formatMoney(data.price_max)}`;
    }
    var compareAtPrice = Utils.formatMoney(compareAtPriceMin);
    var moneyPrice = data.price_varies
      ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
      : priceAmount;
    var unitPriceClass =
      !data.available ||
      typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined'
        ? 'hidden'
        : '';
    const isSale = compareAtPriceMin > priceMin;
    const pricePerOff =
      ((compareAtPriceMin - priceMin) / compareAtPriceMin) * 100;
    const metafieldNotForSale = data.metafields?.find(metafield => metafield.key === 'not_for_sale');
    const isNotForSale = metafieldNotForSale ? metafieldNotForSale.value : false;


    if (isNotForSale === true || isNotForSale === 'true') {
      productPrice = '<p class="not-saleable">この商品はオンラインストアでは販売していません</p>';
    } else {
      productPrice = `
        <div class="price ${soldOut ? 'price--sold-out' : ''} 
          ${isSale ? 'price--on-sale' : ''}
          ${noComparePrice ? 'price--no-compare' : ''}"
        >
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${priceAmount}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">${
                boostPFSConfig.label.sale_price
              }</span>
              <span class="price-item price-item--sale price-item--last">
                ${priceAmount}
              </span>
            </div>
            <span class="price-per-off" style="${isSale ? 'padding: .1rem .2rem;' : ''}">
              ${isSale ? '-' + pricePerOff + '%' : ''}
            </span>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(
                  data.selected_or_first_available_variant &&
                    data.selected_or_first_available_variant.unit_price
                )}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${
                  boostPFSConfig.label.unit_price_separator
                }&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`;
    }
    return productPrice;
  }

  function buildLabels(data) {
    const badgeList = boostPFSAppConfig.general?.badgeList;
    var labelHTML = '';
    if (badgeList?.red_badge_list) {
      badgeList.red_badge_list.forEach(badge => {
        let badgeName = badge.split("：SortOrder=")[0],
          badgeOrder = badge.split("：SortOrder=")[1] || 99;
        if (badgeName && data.tags.includes(badgeName)) {
          labelHTML += `<span class="card-label card-label--red${badgeName === 'NEW' || badgeName === 'SALE' || badgeName === 'OUTLET' ? ' card-label--en' : ''}" style="order: ${badgeOrder};">${badgeName}</span>`;
        }
      });
    }
    if (badgeList?.green_badge_list) {
      badgeList.green_badge_list.forEach(badge => {
        let badgeName = badge.split("：SortOrder=")[0],
          badgeOrder = badge.split("：SortOrder=")[1] || 99;
        if (badgeName && data.tags.includes(badgeName)) {
          labelHTML += `<span class="card-label card-label--green" style="order: ${badgeOrder};">${badgeName}</span>`;
        }
      });
    }
    if (badgeList?.blue_badge_list) {
      badgeList.blue_badge_list.forEach(badge => {
        let badgeName = badge.split("：SortOrder=")[0],
          badgeOrder = badge.split("：SortOrder=")[1] || 99;
        if (badgeName && data.tags.includes(badgeName)) {
          labelHTML += `<span class="card-label card-label--blue" style="order: ${badgeOrder};">${badgeName}</span>`;
        }
      });
    }

    if (labelHTML !== '') {
      labelHTML = `<div class="card-label-list">${labelHTML}</div>`;
    }
    return labelHTML;
  }
  
  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(
        /{{soldOutBadgeClass}}/g,
        boostPFSThemeConfig.custom.sold_out_badge_color_scheme
      );
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') &&
      onSale &&
      !soldOut
    ) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(
        /{{saleBadgeClass}}/g,
        boostPFSThemeConfig.custom.sale_badge_color_scheme
      );
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (
      boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true &&
      Utils.getProductMetafield(data, 'reviews', 'rating') !== null
    ) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >= 0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info
        .replace('{{ rating_value }}', ratingObj.value)
        .replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${
                  boostPFSConfig.custom.accent_icons
                }" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${
        ratingObj.value.scale_max
      }; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(
                  data,
                  'reviews',
                  'rating_count'
                )})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(
                  data,
                  'reviews',
                  'rating_count'
                )} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }

  function buildRivyoV2Review(data) {
    var html = ''
    if (data) {
      html = `<div class="wc_product_review_badge" data-handle="${data.handle}" data-product_id="${data.id}"></div>`
    }
    return html
  }

  function getAspectRatio(data) {
    var width = data == null ? '535' : data.width;
    var height = data == null ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  function buildPromotionBanner(){
    const products_per_page = boostPFSThemeConfig.custom.products_per_page;
    const promotion_contents = boostPFSThemeConfig.custom.promotion_contents;

    function insertBanner(banner_position,banner_image,banner_aspect_ratio,banner_title,banner_link,banner_link_text,banner_text_color_light,banner_button_color_light,banner_text_button_small) {

      if(!banner_image){
        return;
      }
      const banner_page = Math.ceil(banner_position / products_per_page);
      const banner_page_position = banner_position % products_per_page;


      const target_elem = document.querySelectorAll(`.grid__item[data-page="${banner_page}"]`)[banner_page_position - 1];
      const rendered_elem = document.querySelector(`.grid__item--banner[data-banner_position="${banner_page_position}"]`);
      if(target_elem && !rendered_elem){
        const banner_content = `
          ${banner_title ? `<h3 class="grid-banner__title">${banner_title}</h3>` : ""}
          ${banner_link_text ? `
            <button type="button" class="grid-banner__button button button--primary">
              ${banner_link_text}
            </button>
          ` : ""}
        `;
        const banner_html = `
          <li class="grid__item grid__item--banner
            ${ banner_text_color_light === true ? " text-color--light" : ""}
            ${ banner_button_color_light === true ? " button-color--light" : ""}
            ${ banner_text_button_small === true ? " content--small" : ""}
            "
            data-banner_position="${banner_page_position}" >
          ${banner_link ? `
            <a href="${banner_link}" class="grid-banner"
              ${banner_image ? `style="background-image:url('${banner_image}'); aspect-ratio:${banner_aspect_ratio}; height: auto;` : ""}"
            >
              ${banner_content}
            </a>
          ` : `
              <div class="grid-banner"
                ${banner_image ? `style="background-image:url('${banner_image}'); aspect-ratio:${banner_aspect_ratio}; height: auto;` : ""}"
              >
                ${banner_content}
              </div>
          `}
          </li>
        `;
        target_elem.insertAdjacentHTML('beforebegin', banner_html);
      }
    }

    // Banner 1
    if(promotion_contents?.banner1_position){
      
      insertBanner(
        parseInt(promotion_contents.banner1_position),
        promotion_contents.banner1_image,
        promotion_contents.banner1_aspect_ratio,
        promotion_contents.banner1_title,
        promotion_contents.banner1_link,
        promotion_contents.banner1_link_text,
        promotion_contents.banner1_text_color_light,
        promotion_contents.banner1_button_color_light,
        promotion_contents.banner1_text_button_small
      );
    }
    // Banner 2
    if(promotion_contents?.banner2_position){
      insertBanner(
        parseInt(promotion_contents.banner2_position),
        promotion_contents.banner2_image,
        promotion_contents.banner2_aspect_ratio,
        promotion_contents.banner2_title,
        promotion_contents.banner2_link,
        promotion_contents.banner2_link_text,
        promotion_contents.banner2_text_color_light,
        promotion_contents.banner2_button_color_light,
        promotion_contents.banner2_text_button_small
      );
    }
    // Banner 3
    if(promotion_contents?.banner3_position){
      insertBanner(
        parseInt(promotion_contents.banner3_position),
        promotion_contents.banner3_image,
        promotion_contents.banner3_aspect_ratio,
        promotion_contents.banner3_title,
        promotion_contents.banner3_link,
        promotion_contents.banner3_link_text,
        promotion_contents.banner3_text_color_light,
        promotion_contents.banner3_button_color_light,
        promotion_contents.banner3_text_button_small
      );
    }
    // Banner 4
    if(promotion_contents?.banner4_position){
      insertBanner(
        parseInt(promotion_contents.banner4_position),
        promotion_contents.banner4_image,
        promotion_contents.banner4_aspect_ratio,
        promotion_contents.banner4_title,
        promotion_contents.banner4_link,
        promotion_contents.banner4_link_text,
        promotion_contents.banner4_text_color_light,
        promotion_contents.banner4_button_color_light,
        promotion_contents.banner4_text_button_small
      );
    }
  }


  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = currentPage > 1 ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = currentPage < totalPage ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink('page', currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml +=
          pageArr[iPage] == currentPage
            ? boostPFSTemplate.pageItemSelectedHtml
            : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(
        /{{itemUrl}}/g,
        Utils.buildToolbarLink('page', currentPage, pageArr[iPage])
      );
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = '';
          if (paramSort == k) {
            isSelected = 'selected="selected"';
          }
          sortingItemsHtml +=
            '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  };

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function () {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function (e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;
  };

  // Build Additional Elements
  Filter.prototype.afterRender = function (data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' 件の商品');

    buildPromotionBanner(data);

    const colorFilterList = data?.filter?.options?.find(option => option.label === "カラー");
    const colorFilterDom = document.querySelector(".boost-pfs-filter-option-カラー");
    const colorFilterSortOrder = [
      "ブラック","ホワイト","グレー","ブラウン","パープル","ピンク","タン","グリーン","イエロー","オレンジ","レッド","ネイビー","ブルー"
    ];
    if(colorFilterList && colorFilterDom) {
      colorFilterDom.querySelectorAll(".boost-pfs-filter-option-item").forEach(optionItem => {
        const colorTitle = optionItem.querySelector(".boost-pfs-filter-option-value")
          ? optionItem.querySelector(".boost-pfs-filter-option-value").textContent
          : "";
          const orderIndex = colorFilterSortOrder.findIndex(option => option === colorTitle);
          optionItem.style.order = orderIndex !== -1 ? orderIndex : 99;
      });
    }


    const reviewLinkList = document.querySelectorAll(".collection-sneakers__list__card__reviews__link");
    reviewLinkList.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        // Send Datalayer
        const ReviewProductName = link.querySelector(".collection-sneakers__list__card__reviews__product_name").textContent;
        dataLayer.push({
          'event': 'PLP_Review_product',
          'item_name': ReviewProductName,
        });

        // Link to review page
        window.location.href = link.href;
      });
    });
  };
    const isiOS = () => {
    	return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };
    const isSafari = () => {
    	return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    };
    window.addEventListener("pageshow", function(evt){
        if(evt.persisted && Utils.isiOS() || evt.persisted && Utils.isSafari()){
          location.reload();
        }
    }, false);
  /************************** END BUILD TOOLBAR **************************/

  function updateInvalidPageNoindexMeta(data) {
    var currentMetaTag = document.getElementById(boostPFSInvalidPageRobotsMetaId);
    var rawPageParam =
      typeof Globals !== 'undefined' &&
      Globals.queryParams &&
      typeof Globals.queryParams.page !== 'undefined'
        ? Globals.queryParams.page
        : new URLSearchParams(window.location.search).get('page');
    var currentPage = parseInt(rawPageParam, 10);
    var productsPerPage = parseInt(
      (typeof Globals !== 'undefined' &&
        Globals.queryParams &&
        Globals.queryParams.limit) ||
        (typeof boostPFSThemeConfig !== 'undefined' &&
          boostPFSThemeConfig.custom &&
          boostPFSThemeConfig.custom.products_per_page) ||
        (typeof boostPFSConfig !== 'undefined' &&
          boostPFSConfig.custom &&
          boostPFSConfig.custom.products_per_page),
      10
    );
    var totalProduct =
      data && typeof data.total_product !== 'undefined'
        ? parseInt(data.total_product, 10)
        : NaN;
    var totalPage =
      !isNaN(productsPerPage) && productsPerPage > 0 && !isNaN(totalProduct) && totalProduct >= 0
        ? Math.max(Math.ceil(totalProduct / productsPerPage), 1)
        : NaN;
    var shouldNoindex = !isNaN(currentPage) && currentPage > 1 && !isNaN(totalPage) && currentPage > totalPage;

    if (shouldNoindex) {
      if (!currentMetaTag) {
        currentMetaTag = document.createElement('meta');
        currentMetaTag.id = boostPFSInvalidPageRobotsMetaId;
        currentMetaTag.name = 'robots';
        document.head.appendChild(currentMetaTag);
      }

      // Keep this tag separate from Boost's own robots tag so other cleanup scripts do not remove it.
      currentMetaTag.content = 'noindex, nofollow, nosnippet';
      return;
    }

    if (currentMetaTag) {
      currentMetaTag.remove();
    }
  }

  Filter.prototype.afterGetFilterData = function(data, eventType, eventInfo) {
    updateInvalidPageNoindexMeta(data);

    // Our callback function - do not customize
    if (data && Array.isArray(data.products) && data.products.length == 0 && typeof boostPFSAppConfig.general.collection_product_count != 'undefined' && data.products.length != boostPFSAppConfig.general.collection_product_count && !Settings.getSettingValue('general.productAndVariantAvailable') && Settings.getSettingValue('general.enableBackToOriginal')) {
        if (eventType == 'init' && !Globals.hasFilterOptionParam && !Globals.collectionTags && typeof FilterApi.beforeCall != 'function' && typeof FilterApi.beforeCallAsync != 'function') {
            this.errorFilterCallback();
            return;
        }
    }

    // Our neccessary code - do not customize
    this.setData(data, eventType, eventInfo);
  };
})();
